var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.97 3a8.02 8.02 0 00-4.054 7c0 4.418 3.522 8 7.866 8 1.146 0 2.236-.25 3.218-.698C18.39 19.544 15.787 21 12.849 21 7.962 21 4 16.97 4 12s3.962-9 8.849-9h.121z",
    fill: "#23CEE6",
    opacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfMoon);
export default __webpack_public_path__ + "static/media/half-moon.30db72d2eb55e289daaa596ee3e317ac.svg";
export { ForwardRef as ReactComponent };